export default function genererCritereRecherche() {
  return {
    auto: '',
    codes: [],
    libelle: '',
    natureSupportAfficheIds: [],
    typeMaterielIds: [],
    longueurs: [],
    largeurs: [],
  };
}
